import React from 'react';
import { Button, TrashIcon, Box, Link } from '@razorpay/blade/components';
import { Employee, DraftEmployee } from 'api/gql-utils/employeeOnboardingGql/types';
import { User } from 'components/GlobalSearch/types';
import { EmployeeTableNode } from './types';

export const transformSearchResultsToTableNodes = (
  searchResults: User[] | undefined,
): EmployeeTableNode[] => {
  if (!searchResults) return [];

  return searchResults.map((user) => ({
    id: user.people_id.toString(),
    name: user.name,
    email: user.email,
    employeeId: user.employee_id,
    designation: user.designation,
    department: user.department,
    peopleId: user.people_id,
  }));
};

export const transformEmployeesToTableNodes = (
  employees: Employee[] | undefined,
): EmployeeTableNode[] => {
  if (!employees) return [];

  return employees.map((employee) => ({
    id: employee.id.toString(),
    name: employee.name,
    email: employee.email,
    employeeId: employee.employeeId,
    designation: employee.designation,
    department: employee.department,
    peopleId: employee.id,
  }));
};

export const transformDraftEmployeesToTableNodes = ({
  draftEmployees,
  onResumeOnboarding,
  onDeleteDraft,
}: {
  draftEmployees: DraftEmployee[] | undefined;
  onResumeOnboarding: (employeeId: number) => void;
  onDeleteDraft: (employeeId: number) => void;
}): EmployeeTableNode[] => {
  if (!draftEmployees) return [];

  return draftEmployees.map((employee) => ({
    id: employee.id.toString(),
    name: employee.name,
    email: employee.email,
    designation: employee.designation,
    department: employee.department,
    rowHoverAction: (
      <Box display="flex" gap="spacing.4">
        <Button variant="tertiary" size="xsmall" onClick={() => onResumeOnboarding(employee.id)}>
          Resume Onboarding
        </Button>
        <Link
          accessibilityLabel="delete draft"
          variant="button"
          icon={TrashIcon}
          color="neutral"
          onClick={() => onDeleteDraft(employee.id)}
        />
      </Box>
    ),
  }));
};
